import { render } from "./customer-contract.vue?vue&type=template&id=0b06ebbe"
import script from "./customer-contract.vue?vue&type=script&lang=js"
export * from "./customer-contract.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__